module.exports = __webpack_public_path__ + "6b201b3d7a9ca5aeebedc865861ff63a.png";